/**
 * Composable pour gérer la configuration dynamique de Djust
 * Permet de stocker et récupérer les paramètres de configuration depuis les cookies
 */

export const useConfigHelpers = () => {
  /**
   * Définit les cookies de configuration pour l'API
   */
  const setApiConfigCookies = (config: {
    djApiKey?: string;
    djApiClient?: string;
    djStoreId?: string;
    djStoreViewId?: string;
  }) => {
    if (config.djApiKey) {
      const apiKeyCookie = useCookie('dj-api-key', { maxAge: 30 * 24 * 60 * 60 }); // 30 jours
      apiKeyCookie.value = config.djApiKey;
    }

    if (config.djApiClient) {
      const apiClientCookie = useCookie('dj-api-client', { maxAge: 30 * 24 * 60 * 60 });
      apiClientCookie.value = config.djApiClient;
    }

    if (config.djStoreId) {
      const storeIdCookie = useCookie('dj-store-id', { maxAge: 30 * 24 * 60 * 60 });
      storeIdCookie.value = config.djStoreId;
    }

    if (config.djStoreViewId) {
      const storeViewIdCookie = useCookie('dj-store-view-id', { maxAge: 30 * 24 * 60 * 60 });
      storeViewIdCookie.value = config.djStoreViewId;
    }
  };

  /**
   * Récupère la configuration depuis les cookies avec fallback sur les valeurs par défaut
   */
  const getApiConfig = () => {
    const runtimeConfig = useRuntimeConfig();

    return {
      djApiKey: useCookie('dj-api-key').value || runtimeConfig.public.djApiKey,
      djApiClient: useCookie('dj-api-client').value || runtimeConfig.public.djApiClient,
      djStoreId: useCookie('dj-store-id').value || runtimeConfig.public.djStoreId,
      djStoreViewId: useCookie('dj-store-view-id').value || runtimeConfig.public.djStoreViewId,
    };
  };

  /**
   * Réinitialise les cookies de configuration
   */
  const clearApiConfigCookies = () => {
    useCookie('dj-api-key').value = null;
    useCookie('dj-api-client').value = null;
    useCookie('dj-store-id').value = null;
    useCookie('dj-store-view-id').value = null;
  };

  /**
   * Vérifie si une configuration personnalisée est active
   */
  const hasCustomConfig = () => {
    return !!(
      useCookie('dj-api-key').value ||
      useCookie('dj-api-client').value ||
      useCookie('dj-store-id').value ||
      useCookie('dj-store-view-id').value
    );
  };

  return {
    setApiConfigCookies,
    getApiConfig,
    clearApiConfigCookies,
    hasCustomConfig,
  };
};

